import styled, { createGlobalStyle } from "styled-components";

export const FormStyle = styled.form`
  width: 80%;
  max-width: 800px;
`;

export const CalculadoraComplementarForm = styled.div`
    margin-top: 40px;
    background-color: #fff;
    /* width: 80%;
    max-width: 800px; */
    border-radius: 10px;
    padding: 30px;
    .form-title{
        text-align: left;
    }
    label{
        font-size: 1.3rem;
        font-weight: 400;
        text-align: left;
    }

    .declaracao-pergunta{
        text-align: left;
        margin-bottom: 15px;
    }

    .declaracao{
        margin-left: 30px;

        div{
            text-align: left;
        }

        .radio {
            min-width: 20px;
            min-height: 20px;
            margin: 0px 10px 20px 0px;
        }

        .nota-fiscal-container{
            margin-left: 30px;

            .nota-fiscal{
                align-items: flex-end;
                justify-content: normal;
                margin: 5px 0px 20px 0px;

                p{
                    color: gray;
                    font-size: 12px;
                    margin 7px;
                }
            }

        }

        .declaracao-conteudo{
            margin-left: 30px;

            textarea{
                height: 61px;
                resize: none;
                padding 7px;
            }
            p{
              color: gray;
              font-size: 12px;
            }
        }

        .declaracao-disable{
            color: gray;

            .input-disable{
                min-width: 20px;
                min-height: 20px;
                margin-right: 10px;
            }

            p{
                font-size: 80%;
            }
        }
       
    }

    .valores-declaracao{
        text-align: left;
        margin-bottom: 40px;
        span{
            color: #009f57;
            font-weight: 600;
        }
        .valorTotalWarning{
            color: #e6b222;
        }
    }

    @media (max-width: 2560px) {
        .section-half{
            display: flex;
            justify-content: space-between;
        }

        .section-half > div:first-child{
            margin-right: 2em;
            flex-grow: 1;
        }

        .section-half > div:last-child{
            flex-grow: 1;
        }
    }

    .multiselect-custom {
        width: 100%;
        padding: 0.5rem 0.5rem !important;
    }

    .p-multiselect,
    .p-multiselect-panel,
    .p-multiselect-item,
    .p-multiselect-filter-container input {
        font-size: 1em;
        font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,
            "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    @media (max-width: 1024px) {

    }

    @media (max-width: 770px) {
        .section-half{
            flex-direction: column;
        }

        .section-half > div:first-child{
            margin-right: 0;
        }
    }
    /* @media(max-width: 600px){
        
    } */

.dce-container {
  margin-top: 10px;
  /* já está dentro de .declaracao, que tem margin-left: 30px — não duplicar */

  .dce-title {
    font-weight: 600;
    margin-bottom: 10px;
    text-align: left;
    font-size: 1.5rem;
  }

  .dce-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    font-size: 1.4rem;

    th, td {
      text-align: left;
      padding: 8px 10px;
      vertical-align: middle;
    }

    th {
      border-bottom: 2px solid #ccc;
      font-weight: 600;
      color: #333;
    }

    input {
      box-sizing: border-box;
      border: 1px solid #999;
      border-radius: 3px;
      padding: 6px 8px;
      font-size: 1.3rem;
      width: 100%;
      background: #fff;
      text-align: left;
    }
  }

  .dce-action {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.3rem;
    padding: 0;
  }

  .dce-action.editar,
  .dce-action.excluir,
  .dce-action.salvar {
    color: #812990;
    font-weight: 600;
  }
  .dce-action.adicionar {
    color: #812990;
    font-weight: 600;
  }

  .dce-action.adicionar:disabled {
    color: #999;
    cursor: default;
  }

  .dce-add-btn {
    background: none;
    border: none;
    color: #812990;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 500;
    margin-top: 8px;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .dce-gerar-btn-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }

  .dce-gerar-btn {
    background-color: #e8e8e8;
    border: 1px solid #bbb;
    border-radius: 4px;
    padding: 8px 24px;
    font-size: 1.2rem;
    cursor: pointer;
    color: #333;

    &:hover {
      background-color: #812990;
      color: white;
      border-color: #812990;
    }
  }

  @media (max-width: 770px) {
    overflow-x: auto;

    .dce-table {
      min-width: 600px;
    }
  }
}
`;

export const BtnSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .button {
    font-size: 1.6rem;
    ion-icon {
      margin-right: 10px;
    }
  }

  .alterar-transportadora {
    border: none;
    background-color: transparent;
    color: #812990;
    font-weight: 600;
    letter-spacing: 0.3px;
    display: flex;
    align-items: center;
  }

  .add-carrinho {
    margin-top: 20px;
    /*
		margin-bottom: 20px; */
    background-color: white;
    color: #812990;
    font-weight: 600;
    letter-spacing: 0.3px;
  }

  .add-carrinho:hover {
    background: rgba(255, 255, 255, 0.7);
  }

  .finalizar-pagamento {
    margin-top: 10px;
    /*
		margin-bottom: 20px; */
    background: rgb(131, 43, 146);
    background: linear-gradient(267deg, rgba(131, 43, 146, 1) 39%, rgba(160, 69, 176, 1) 100%);
    color: white;
    font-weight: 600;
    letter-spacing: 0.3px;
    border: none;
    padding-left: 2em;
    padding-right: 2em;
  }

  .finalizar-pagamento:hover {
    background: #c986d8;
    color: white;
  }
`;

export const GlobalFilterStyle = createGlobalStyle`
  .custom-filter-panel {
    background: #ffffff !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
    border: 1px solid #e5e7eb !important;
  }

  .custom-filter-panel .p-multiselect-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    padding: 15px 15px 5px 15px !important;
    background: transparent !important;
    border-bottom: 1px solid #e5e7eb !important;
  }

  .custom-filter-panel .p-multiselect-close {
    display: none !important;
  }

  .custom-filter-panel .p-multiselect-filter-container {
    width: 100% !important;
    order: -1 !important;
    margin-bottom: 15px !important;
    position: relative !important;
  }

  .custom-filter-panel .p-multiselect-filter-container .p-inputtext {
    width: 100% !important;
    height: 40px !important;
    padding: 5px 10px 5px 35px !important;
    border-radius: 6px !important;
    border: 1px solid #d1d5db !important;
    font-family: inherit !important;
    color: #111827 !important;
    font-weight: 600 !important;
    font-size: 1.15rem !important;
  }

  .custom-filter-panel .p-multiselect-filter-container .p-multiselect-filter-icon {
    position: absolute !important;
    left: 12px !important;
    right: auto !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    color: #6b7280 !important;
  }

  .custom-filter-panel .p-multiselect-item {
    padding: 8px 15px !important;
    border-radius: 4px !important;
    margin: 2px 10px !important;
    color: #282828 !important;
    font-weight: 500 !important;
    font-size: 1.35rem !important;
  }

  .custom-filter-panel .p-multiselect-item.p-highlight {
    background-color: rgba(136,48,152,0.05) !important;
    color: rgba(136,48,152,1) !important;
    font-weight: 600 !important;
  }

  .custom-filter-panel .p-multiselect-empty-message {
    padding: 1rem 1.5rem !important;
    color: #6b7280 !important;
    font-weight: 500 !important;
    font-size: 1.1rem !important;
    text-align: center !important;
  }
`;
export const DceWaiting = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1.5rem;
  gap: 1rem;
  background: #f8f9fc;
  border-radius: 8px;
  border: 1px solid #e2e8f4;

  .dce-spinner-wrap {
    position: relative;
    width: 56px;
    height: 56px;
  }

  .dce-spinner-outer {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 2px solid #e2e8f4;
    border-top-color: #185fa5;
    animation: dce-spin 1s linear infinite;
  }

  .dce-spinner-inner {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid #e2e8f4;
    border-bottom-color: #1d9e75;
    animation: dce-spin 0.7s linear infinite reverse;
  }

  .dce-waiting-title {
    font-weight: 600;
    color: #1a202c;
    margin: 0;
    font-size: 15px;
    text-align: center;
  }

  .dce-waiting-sub {
    font-size: 13px;
    color: #718096;
    margin: 4px 0 0;
    text-align: center;
  }

  .dce-dot-row {
    display: flex;
    gap: 6px;
  }

  .dce-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #a0aec0;
    animation: dce-pulse 1.4s ease-in-out infinite;
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  .dce-steps {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: fit-content;
    margin: 0 auto;
  }

  .dce-step {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #718096;
  }

  .dce-step-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    flex-shrink: 0;
  }

  .dce-step.done .dce-step-icon {
    background: #f0fff4;
    color: #38a169;
  }
  .dce-step.done {
    color: #2d3748;
  }

  .dce-step.active .dce-step-icon {
    background: #ebf8ff;
    color: #3182ce;
    animation: dce-pulse 1s ease-in-out infinite;
  }
  .dce-step.active {
    color: #2d3748;
    font-weight: 500;
  }

  .dce-step.pending .dce-step-icon {
    background: #f7fafc;
    color: #a0aec0;
    border: 1px solid #e2e8f0;
  }

  @keyframes dce-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes dce-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }

  &.dce-error-block {
    border: 1px solid #f0c2c2;
    background: #fdf2f2;
  }

  .dce-error-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #cc0000;
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px auto;
  }

  .dce-step.error .dce-step-icon {
    background: #cc0000;
    color: #fff;
  }

  &.dce-success-block {
    border: 1px solid #b7e0c0;
    background: #f1faf3;
  }

  .dce-success-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #1aa251;
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px auto;
  }
`;
